module.exports = __webpack_public_path__ + "static/assets/7b20e9e43208910082e396f927a030bc.svg";